import { DefaultTheme } from 'styled-components';

import { ThemeMode } from '@sternum/web/components/theme/main/ThemeMode.context';

/**
 * ct is shortcut for "choose theme"
 */
export function ct<T>(stylesPerThemeMode: Record<ThemeMode, T>): ({ theme }: { theme: DefaultTheme }) => T {
  return function choiceFn({ theme }: { theme: DefaultTheme }): T {
    switch (theme.mainThemeMode) {
      case 'Dark':
        return stylesPerThemeMode.Dark;
      case 'Light':
        return stylesPerThemeMode.Light;
      default:
        console.warn(`Unknown theme mode "${theme.mainThemeMode}" - using "Light"`);

        return stylesPerThemeMode.Light;
    }
  };
}
